export const BACKGROUND_COLOR = '#e9edec'
export const GRID_LINE_COLOR = '#d9dfdb'
export const COLORS = ['#c5ae31', '#5fed83', '#bfbfbf', '#12bf3e', '#ae85ff', '#ffffff'] as const
